import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { pushEvent } from "@/services/dataLayerLogin";
import { store } from "@/state/store";
import SharedButton from "@SharedVueComponents/SharedButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FacebookLogin',
  setup(__props) {

function startFacebookLogin() {
	window.location.href = `${store.oAuthSignIn}?kc_idp_hint=facebook`;
	pushEvent("FacebookButton");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SharedButton, {
    variant: "secondary",
    "append-icon": "social-facebook",
    "icon-prefix": false,
    "aria-label": "Facebook Anmeldung",
    onClick: startFacebookLogin
  }))
}
}

})